module.exports = "/work-site/img/quality.109a0920.png";